export const catalog_matrix = [
    {form_key:'state_id', catalog_key:'mexico_states'},
]
